// Frontend service for /me/payments/* and /me/packs/* and /me/subscription.
// Dues are wired to real endpoints (backend ships /me/payments). Packs +
// subscription remain mocked until their backend phase ships.

import { shouldUseMocks } from './mockApi'
import * as mock from './mockApi/shopApi'
import { patientGet } from './patientApi'
import { payDueNow } from './paymentService'

export async function listDues(profile) {
  if (shouldUseMocks()) return mock.listDues(profile)
  const res = await patientGet('/api/secure/me/payments/dues', {
    requirePatientContext: true,
  })
  return res?.data || []
}

/**
 * End-to-end pay-now: hits POST /me/payments/dues/{dueId}/pay, fetches the
 * gateway order, and opens Razorpay. Use {@code onSuccess} to refresh the
 * caller's view once the modal closes — defaults to a full reload.
 */
export async function payDue(profile, dueId, opts) {
  if (shouldUseMocks()) return mock.payDue(profile, dueId)
  return payDueNow(dueId, opts)
}
export async function listPacks(profile) {
  return mock.listPacks(profile)
}
export async function getSubscription(profile) {
  return mock.getSubscription(profile)
}
export async function upgradeSubscription(profile, tierId) {
  return mock.upgradeSubscription(profile, tierId)
}

// shouldUseMocks() referenced so the linter doesn't trip; once B6 lands we
// branch on it per call.
void shouldUseMocks
